module.exports = __webpack_public_path__ + "img/w60.69a5d97a.svg";